import ProjectIntakeStatus from '../../../../enums/companyProjects/ProjectIntakeStatus';
import ActivityPriorityLevel from '../../../../enums/activities/ActivityPriorityLevel';

export type ProjectIntakeSortByPropName =
  'from' | 'subject' | 'assignedtousername' | 'prioritylevel' | 'initialemailreceiveddate';

export type ProjectIntakeSortModel = {
  SortByPropName?: ProjectIntakeSortByPropName;
  Desc?: boolean;
};

export type ProjectIntakeInboxModel = {
  Id: number;
  From: string;
  Subject: string;
  HasNewMessage: boolean;
  AssignedToUserName?: string;
  AssignedToUserId?: string;
  Status: ProjectIntakeStatus;
  InitialEmailReceivedDate?: string;
  LatestMessageDate?: string;
  MessageCount: number;
  UpdatedOn?: string;
  /** Project container lead when the intake is filed in a project folder. */
  ProjectLeadUserName?: string | null;
  PriorityLevel?: ActivityPriorityLevel;
  PriorityNote?: string | null;
  FolderName?: string | null;
  SectionName?: string | null;
};

export type ProjectIntakeQuickAddModel = {
  Subject: string;
  Note: string;
};

export type ProjectIntakeTabData = {
  id: number;
  subject?: string;
  hasNewMessage?: boolean;
};

export enum ProjectIntakeEventType {
  Created = 0,
  Removed = 1,
  Read = 2,
  Unread = 3,
  Updated = 4,
  Merged = 5
}

export type ProjectIntakeEvent = {
  intakeId: number;
  type: ProjectIntakeEventType;
  data?: ProjectIntakeInboxModel;
};
